import * as o from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/FileAudio.es.js";
const e = o.forwardRef((i, r) => /* @__PURE__ */ o.createElement(t, { ref: r, ...i, weights: a }));
e.displayName = "FileAudioIcon";
const s = e;
export {
  s as FileAudio,
  e as FileAudioIcon
};
